import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

import { normalizeHashtagBody } from '@caliu/utils'
import { HASHTAG_REGEX } from '../lib/hashtags'

export function createHashtagExtension(onTagClick?: (tagName: string) => void) {
  return Extension.create({
    name: 'hashtag',

    addProseMirrorPlugins() {
      return [
        new Plugin({
          key: new PluginKey('hashtag'),
          props: {
            decorations(state) {
              const decos: Decoration[] = []
              state.doc.descendants((node, pos, parent) => {
                // Skip code blocks entirely
                if (node.type.name === 'codeBlock') return false
                if (!node.isText) return
                // Skip inline code marks
                if (node.marks.some((m) => m.type.name === 'code')) return
                // Skip text inside code block parents (e.g. custom code block node views)
                if (parent?.type.name === 'codeBlock') return
                const text = node.text ?? ''
                let match
                HASHTAG_REGEX.lastIndex = 0
                while ((match = HASHTAG_REGEX.exec(text)) !== null) {
                  decos.push(
                    Decoration.inline(
                      pos + match.index,
                      pos + match.index + match[0].length,
                      { class: 'caliu-hashtag' },
                    ),
                  )
                }
              })
              return DecorationSet.create(state.doc, decos)
            },

            handleDOMEvents: {
              mousedown(_view, event) {
                if (!onTagClick) return false
                const target = event.target as HTMLElement
                if (!target.classList.contains('caliu-hashtag')) return false
                event.preventDefault()
                return true
              },
              click(_view, event) {
                if (!onTagClick) return false
                const target = event.target as HTMLElement
                if (!target.classList.contains('caliu-hashtag')) return false
                // Decoration text is `#body` or `#multi word#`: strip both hashes
                // and normalize so the handle matches what extraction stored.
                const tagName = normalizeHashtagBody(
                  target.textContent?.replace(/^#/, '').replace(/#$/, '') ?? '',
                )
                if (tagName) onTagClick(tagName)
                return true
              },
            },
          },
        }),
      ]
    },
  })
}

// Backward-compatible default export for read-only contexts (share page etc.)
export const HashtagExtension = createHashtagExtension()
